module.exports = __webpack_public_path__ + "img/2_user.e8257e33.svg";